/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import { Button, Table, Glyphicon } from 'react-bootstrap'
import { connect } from 'react-redux'
import swal from 'sweetalert2'
import axios from 'axios'

import HandleVendorModal from './HandleVendorModal'
import VendorRow from './VendorRow'
import AddVendorBox from './AddVendordBox'
import VendorCarrierMappingModal from './VendorCarrierMappingModal'
import VendorHistoryModal from './VendorHistoryModal'
import { swalError } from '../../../common/components/Swaler'
import { createVendor, updateVendor, deleteVendor } from '../../../common/redux/collectionActions'
import MergeVendorsModal from './MergeVendorsModal'

type Props = {
  vendors: [
    {
      _id: String,
      email: String,
      tags: [String],
      lastActive: String,
    }
  ],
  addVendor: Function,
  submitVendor: Function,
  removeVendor: Function,
}

const defaultSortDirection = -1

const Vendors = ({ vendors, addVendor, submitVendor, removeVendor }: Props) => {
  const [showAddVendorBox, setShowAddVendorBox] = useState(false)
  const [activeVendor, setActiveVendor] = useState()
  const [selectedVendorCarrierMapping, setSelectedVendorCarrierMapping] = useState()
  const [selectedVendorToMerge, setSelectedVendorToMerge] = useState()
  const [sortProperty, setSortProperty] = useState('')
  const [sortDirection, setSortDirection] = useState(defaultSortDirection)
  const [vendorHistory, setVendorHistory] = useState()

  const onChangeSort = (newSortProperty) => {
    if (sortProperty === newSortProperty) {
      setSortDirection(sortDirection * -1)
    } else {
      setSortProperty(newSortProperty)
      setSortDirection(defaultSortDirection)
    }
  }

  const sortedVendors = vendors
    ? [...vendors].sort((a, b) => {
        if (sortProperty === 'lastActive') {
          if (!a.lastActive) return 1
          if (!b.lastActive) return -1

          if (new Date(a.lastActive).getTime() < new Date(b.lastActive).getTime()) return sortDirection
          if (new Date(a.lastActive).getTime() > new Date(b.lastActive).getTime()) return sortDirection * -1
        }

        if (sortProperty === 'name') {
          if (!a.name) return 1
          if (!b.name) return -1
        }

        const aProp = (a[sortProperty] || '').toLowerCase()
        const bProp = (b[sortProperty] || '').toLowerCase()
        if (aProp < bProp) {
          return sortDirection
        }
        if (aProp > bProp) {
          return sortDirection * -1
        }
        return 0
      })
    : null

  const onDisplayHistory = (id) => {
    setVendorHistory(null)

    axios
      .get(`${window.MYQLOCX_API}/subject/admin/vendors/${id}/history`)
      .then(({ data }) => {
        setVendorHistory(data)
      })
      .catch(() => {
        swalError('Ajdå', 'Något gick fel')
      })
  }

  return (
    <div>
      {selectedVendorCarrierMapping ? <VendorCarrierMappingModal vendor={selectedVendorCarrierMapping} closeModal={() => setSelectedVendorCarrierMapping(null)} /> : null}
      {selectedVendorToMerge ? <MergeVendorsModal vendor={selectedVendorToMerge} closeModal={() => setSelectedVendorToMerge(null)} /> : null}

      <Button onClick={() => setShowAddVendorBox(!showAddVendorBox)} style={{ marginBottom: 10 }} className="add-lock-btn" bsSize="small" block>
        <Glyphicon glyph="glyphicon glyphicon-plus" /> &nbsp; Lägg till ny leverantör
      </Button>
      {showAddVendorBox && <AddVendorBox addVendor={addVendor} closeAddVendorBox={() => setShowAddVendorBox(false)} />}
      <Table responsive style={{ backgroundColor: 'white' }}>
        <thead>
          <tr>
            <th />
            <th style={{ width: '10%' }} onClick={() => onChangeSort('name')}>
              <div style={{ float: 'left' }}>{sortProperty === 'name' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>
              Namn
            </th>
            <th style={{ width: '10%' }}>Email</th>
            <th style={{ width: '30%' }}> Taggar</th>
            <th onClick={() => onChangeSort('lastActive')}>
              <div style={{ float: 'left' }}>{sortProperty === 'lastActive' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>
              Senast aktiv
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedVendors.map((v) => (
            <VendorRow key={v._id} {...v} setActiveVendor={() => setActiveVendor(v)} setSelectedVendorCarrierMapping={() => setSelectedVendorCarrierMapping(v)} setSelectedVendorToMerge={() => setSelectedVendorToMerge(v)} onDisplayHistory={() => onDisplayHistory(v._id)} />
          ))}
        </tbody>
      </Table>
      <HandleVendorModal
        isModalOpen={!!activeVendor}
        closeModal={() => setActiveVendor()}
        vendor={activeVendor}
        submitVendor={(obj) =>
          submitVendor(obj)
            .then(() => {
              swal.fire({
                type: 'success',
                title: 'Sparat!',
                showConfirmButton: false,
                timer: 1500,
              })
              setActiveVendor()
            })
            .catch((err) => {
              if (err.isAxiosError) {
                swal.fire({
                  type: 'error',
                  title: err.response.data.message,
                })
              }
              console.log(err)
            })
        }
        removeVendor={() =>
          removeVendor(activeVendor._id)
            .then(() => {
              swal
                .fire({
                  type: 'warning',
                  title: 'Ta bort leverantör',
                  text: 'Vill du verkligen ta bort leverantören?',
                  showCancelButton: true,
                  confirmButtonColor: '#006e78',
                  cancelButtonColor: '#CE4547',
                  confirmButtonText: 'Ja',
                  cancelButtonText: 'Nej!',
                })
                .then((r) => {
                  if (!r.value) return

                  swal.fire({
                    type: 'success',
                    timer: 1500,
                    title: 'Leverantör raderad',
                    showConfirmButton: false,
                  })
                  setActiveVendor()
                })
            })
            .catch(() => {
              swal.fire({
                type: 'error',
                title: 'Oj. Någonting gick fel',
              })
            })
        }
      />
      <VendorHistoryModal closeModal={() => setVendorHistory(null)} history={vendorHistory} />
    </div>
  )
}

const mapState = (state) => ({
  vendors: state.collectionData.vendors,
})

const mapDispatch = (dispatch) => ({
  addVendor: (obj) => dispatch(createVendor(obj)),
  submitVendor: (obj) => dispatch(updateVendor(obj)),
  removeVendor: (id) => dispatch(deleteVendor(id)),
})

export default connect(
  mapState,
  mapDispatch
)(Vendors)
